<button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>account_circle</mat-icon>
    <mat-icon class="near">arrow_drop_down</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <a mat-menu-item [routerLink]="['/main/profile']">
        <mat-icon>person</mat-icon>
        <span>Profile</span>
    </a>
    <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Sign Out</span>
    </button>
</mat-menu>
